@switch (columnName) {
  @case ('departments') {
    @for (department of element.departments; track $index) {
      <div>
        {{ department }}
      </div>
    }
  }
  @case ('departmentType') {
    @if (element.type === 2) {
      <div>
        {{ 'LandBased' | translate }}
      </div>
    } @else {
      <div>
        {{ 'Vessel' | translate }}
      </div>
    }
  }
  @case ('status') {
    <app-ui-pill name="{{ element.status | lowercase }}"></app-ui-pill>
  }
  @case ('vesselType') {
    <div>
      {{ element.vesselType | translate }}
      <br />
    </div>
  }
  @case ('vesselTypes') {
    @for (vesselTypes of element[columnName]; track vesselTypes) {
      <div>
        {{ vesselTypes | translate }}
      </div>
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
